import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { PromoteContainer } from '../PromoteContainer';
import { ChannelsBody } from './ChannelsBody';

interface PromoteChannelsScreenProps {
  accountId: number;
}

/**
 * The Channels page of the Promote menu: its head over the channels. Settings → Connections draws
 * the same `ChannelsBody` under the Settings head. The native apps read the ids of this head too.
 */
const PromoteChannelsScreenComponent: React.FC<PromoteChannelsScreenProps> = ({ accountId }) => {
  const intl = useIntl();
  return (
    <PromoteContainer
      title={intl.formatMessage({ id: 'app.sml.promote.tab.channels', defaultMessage: 'Channels' })}
      subtitle={intl.formatMessage({
        id: 'app.sml.promote.channels.intro',
        defaultMessage:
          'Where your posts go, and how each channel grows. MUSIC24 reads your followers and your posts once a day.',
      })}
    >
      <ChannelsBody accountId={accountId} />
    </PromoteContainer>
  );
};

export const PromoteChannelsScreen = TypedMemo(PromoteChannelsScreenComponent);
